import { useState } from "react";
import ThankYou from "../ThankYou";
import { submitToWeb3Forms } from "@/lib/web3forms";

export default function AppointmentForm() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await submitToWeb3Forms(e.currentTarget, {
        subject: "New appointment request — MTS website",
        fromName: "MTS Website — Appointment Form",
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <ThankYou
        testId="appointment-thank-you"
        heading="Thank you — your request has been received."
        body="Our team will reach out to confirm or update your appointment. If this is time-sensitive, please call (902) 706-6287 during business hours."
      />
    );
  }

  return (
    <form onSubmit={onSubmit} className="space-y-5" data-testid="appointment-form">
      <input type="checkbox" name="botcheck" tabIndex="-1" autoComplete="off" className="hidden" aria-hidden="true" />
      <div className="grid gap-5 sm:grid-cols-2">
        <div>
          <label htmlFor="a-name" className="field-label">Full name</label>
          <input id="a-name" name="name" type="text" required className="field-input" autoComplete="name" data-testid="appointment-input-name" />
        </div>
        <div>
          <label htmlFor="a-phone" className="field-label">Phone</label>
          <input id="a-phone" name="phone" type="tel" required className="field-input" autoComplete="tel" data-testid="appointment-input-phone" />
        </div>
        <div className="sm:col-span-2">
          <label htmlFor="a-email" className="field-label">Email</label>
          <input id="a-email" name="email" type="email" required className="field-input" autoComplete="email" data-testid="appointment-input-email" />
        </div>
        <div>
          <label htmlFor="a-date" className="field-label">Appointment date <span className="text-slate-400 font-normal">(if known)</span></label>
          <input id="a-date" name="appointment_date" type="date" className="field-input" data-testid="appointment-input-date" />
        </div>
        <div>
          <label htmlFor="a-address" className="field-label">Home address</label>
          <input id="a-address" name="address" type="text" required className="field-input" autoComplete="street-address" data-testid="appointment-input-address" />
        </div>
      </div>

      <div>
        <label htmlFor="a-message" className="field-label">Message</label>
        <textarea id="a-message" name="message" className="field-textarea" placeholder="Let us know if you'd like to confirm, reschedule, or cancel." data-testid="appointment-input-message" />
      </div>

      {error && (
        <p className="text-sm text-red-600" role="alert" data-testid="appointment-error">{error}</p>
      )}

      <button type="submit" className="btn-primary" disabled={submitting} data-testid="appointment-submit">
        {submitting ? "Sending…" : "Send request"}
      </button>
    </form>
  );
}
